export const name = "SAFE_ADD";
export const summary = `Equivalent to the addition operator (\`X + Y\`), but returns \`NULL\` if overflow occurs.`;
export const reference = `
## SAFE_ADD

Equivalent to the addition operator (\`X + Y\`), but returns \`NULL\` if overflow occurs.

\`\`\`
SAFE_ADD(X, Y)
\`\`\`

### Description

Equivalent to the addition operator (\`+\`), but returns\`NULL\` if overflow occurs.

| X | Y | SAFE\\_ADD(X, Y) |
| --- | --- | --- |
| 5 | 4 | 9 |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| \`INT64\` | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| \`NUMERIC\` | \`NUMERIC\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| \`FLOAT64\` | \`FLOAT64\` | \`FLOAT64\` | \`FLOAT64\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
